module.exports = __webpack_public_path__ + "static/media/5_NL.d4ce4521.mp3";